import type { ApiClient } from '../../../shared/api/api-client';

export type BugReportPayload = {
  title?: string;
  ticket_kind?: 'bug' | 'improvement' | 'support' | 'anonymous';
  what_wrong: string;
  expected: string;
  ai_restatement?: string;
  restatement_confirmed?: boolean;
  source: 'dock' | 'assistant' | 'portal';
  conversation_id?: number | null;
  plan_id?: number | null;
  context: Record<string, unknown>;
  screenshot_media_key?: string;
};

export type BugReportCreated = { id: number; created_at: string };

export async function postBugReport(api: ApiClient, payload: BugReportPayload): Promise<BugReportCreated> {
  return api.request<BugReportCreated>('/auth/me/bug-reports', { method: 'POST', body: payload });
}

export async function fetchBugRestatement(
  api: ApiClient,
  payload: { what_wrong: string; expected: string; route: string }
): Promise<{ available: boolean; restatement: string; title?: string }> {
  return api.request<{ available: boolean; restatement: string; title?: string }>('/assistant/bug-report/restate', {
    method: 'POST',
    body: payload
  });
}

export async function uploadBugScreenshot(api: ApiClient, blob: Blob): Promise<string> {
  const form = new FormData();
  form.append('file', blob, 'bug-report-screenshot.png');
  const res = await api.request<{ key?: string }>('/media/upload', { method: 'POST', bodyFormData: form });
  const key = (res.key ?? '').trim();
  if (!key) throw new Error('Сервер не вернул ключ скриншота');
  return key;
}
